function AuthValidation(to, from, app) {
  return new Promise(function(resolve, reject) {
    if (to.meta.requireAuth) {
      app.$http.get("/json/profile/check_auth").then(
        response => {
          if (response.data.code === 0) {
            resolve({});
          } else {
            reject({
              data: {
                name: "Login"
              }
            });
          }
        },
        response => {
            reject({
              data: {
                name: "Login"
              }
            });
        }
      );
    } else {
      resolve({});
    }
  });
}

export default AuthValidation;

// resolve({
//   lang: to.params.lang
// })
//
// reject({
//   error: 'invalid.lang',
//   data:{
//     name: to.name,
//     params: {
//       lang : LANGS[0] }
//   }
// })
